import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import autoplayModel from "slotworks/model/autoplay-model";
import Components from "slotworks/components/components";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import Layers from "slotworks/graphics/layers/layers";

export default function ShowPromoFSafterFreespins() {
    if(campaignsModel.isFreespinsActive()) {
        Components.promoBetBar.enablePromoUI();
        if(!campaignsModel.freespins.isComplete) {
            if(autoplayModel.isAutoPlaying()) {
                smartButton.setFlag(SmartButtonFlag.AUTO_SPIN, true);
            }
            else {
                smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);
            }
        }
        Layers.BetBar.hide();
        Layers.PromoBetBar.show();
        Layers.SmartButton.show();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/promo-free-spins/show-pfs-after-freespins.ts